import React from 'react';
import iconCard   from '../../assets/credit-card.svg';
import iconCash   from '../../assets/coins.svg';
import iconTicket from '../../assets/ticket-alt.svg';
import { PAYMENT_METHODS } from './constants';

const ICON_MAP = {
    card:   iconCard,
    cash:   iconCash,
    ticket: iconTicket,
};

/**
 * PaymentSelector — panneau droit de l'étape 3.
 *
 * onSelectMethod remplace setSelectedMethod : le hook intercepte
 * le clic sur "Espèces" pour ouvrir la CashModal avant de valider.
 */
const PaymentSelector = ({
    selectedMethod,
    onSelectMethod,   // ← handleSelectMethod du hook (intercepte cash)
    printReceipt,
    setPrintReceipt,
    disabled = false,
}) => (
    <div className="flex-col" style={{ gap: 12 }}>

        {/* Toggle imprimer reçu */}
        <div className="toggle-receipt-row">
            <label className="switch">
                <input
                    type="checkbox"
                    checked={printReceipt}
                    onChange={e => setPrintReceipt(e.target.checked)}
                />
                <span className="slider"></span>
            </label>
            <span style={{ fontSize: 13 }}>Imprimer reçu</span>
        </div>

        <span className="section-label">Moyens de paiements :</span>
        <div className="payment-options-grid">
            {PAYMENT_METHODS.map(pm => (
                <button
                    key={pm.id}
                    className={[
                        'payment-option-btn',
                        pm.colorClass,
                        selectedMethod === pm.id ? 'pm-selected' : '',
                    ].join(' ')}
                    disabled={disabled}
                    onClick={() => onSelectMethod(pm.id)}
                >
                    <img
                        src={ICON_MAP[pm.iconKey] ?? iconCard}
                        alt={pm.label}
                        className="white_svg size-20"
                    />
                    <span>{pm.label}</span>
                </button>
            ))}
        </div>
    </div>
);

export default PaymentSelector;
